import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import MisTurnoCard from "./MisTurnoCard.jsx";
import Loader from "../../components/Loader/Loader.jsx"; 
import "./MisTurnos.css";
import {toast} from "react-toastify"
import { useAuth } from "../../context/authContext.jsx";
import { TextField } from "@mui/material";
import { obtenerMisTurnos, cancelarMiTurno, proponerNuevaFecha } from "../../service/MisTurnosService.js";

import { 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle, 
  Button 
} from "@mui/material";
import EventBusyRoundedIcon from '@mui/icons-material/EventBusyRounded';

const parsearFecha = (fechaString) => {
  const [dia, mes, anio] = fechaString.split("/");
  return new Date(anio, mes - 1, dia);
};

const MisTurnos = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [turnos, setTurnos] = useState([]);
  const [cargando, setCargando] = useState(true);

  const [modalAbierto, setModalAbierto] = useState(false);
  const [turnoACancelar, setTurnoACancelar] = useState(null);

  const [modalModificarAbierto, setModalModificarAbierto] = useState(false);
  const [datosNuevaFecha, setDatosNuevaFecha] = useState({ idTurno: null, fecha: "", hora: "" });

  const { usuario } = useAuth();
  const usuarioId = usuario?.pacienteId || usuario?.medicoId || usuario?._id;

  const turnoIdDestacado = searchParams.get("turnoId"); 
  const filtroActivo = searchParams.get("recientes") === "true" ? "proximos" : "todos";
  const [motivoCancelacion, setMotivoCancelacion] = useState("");

  useEffect(() => {
    const cargarTurnos = async () => {
      setCargando(true);
      try {
        const turnosDeLaBD = await obtenerMisTurnos(usuarioId);

        setTurnos(turnosDeLaBD);
      } catch (error) {
        console.error("Error al cargar los turnos:", error);
        toast.error("Hubo un problema al cargar tus turnos.",{toastId: "error-carga"});
      } finally {
        setCargando(false);
      }
    };
    cargarTurnos();
  }, [usuarioId]);

  const manejarCambioPestaña = (filtro) => {
    if (filtro === "proximos") {
      setSearchParams({ recientes: "true" });
    } else {
      setSearchParams({}); 
    }
  };

  const intentarCancelar = (id, medico) => {
    setTurnoACancelar({ id, medico });
    setModalAbierto(true);
  };

  const cerrarModal = () => {
      setModalAbierto(false);
      setTurnoACancelar(null);
      setMotivoCancelacion("");
  };

  const confirmarCancelacion = async () => {
    if (turnoACancelar) {
      try {
        await cancelarMiTurno(
            usuarioId,
            turnoACancelar.id,
            motivoCancelacion
        );
        
        setTurnos(turnos.map((turno) =>
            turno.id === turnoACancelar.id
                ? {
                    ...turno,
                    estado: "CANCELADO",
                    motivoCancelacion
                }
                : turno
        ));
        toast.success(`Turno con ${turnoACancelar.medico} cancelado correctamente.`);
      } catch (error) {
        console.error("Error completo al cancelar:", error.response || error);
        toast.error("No se pudo cancelar el turno. Intentalo de nuevo.");
      }
    }
    setModalAbierto(false);
    setTurnoACancelar(null);
    setMotivoCancelacion("");
  };

  const abrirModalModificar = (id) => {
    setDatosNuevaFecha({ idTurno: id, fecha: "", hora: "" });
    setModalModificarAbierto(true);
  };

  const confirmarModificacion = async () => {
    if (!datosNuevaFecha.fecha || !datosNuevaFecha.hora) {
      toast.warning("Por favor, elegí una nueva fecha y horario.");
      return;
    }

    try {
      await proponerNuevaFecha(usuarioId, datosNuevaFecha.idTurno, datosNuevaFecha.fecha, datosNuevaFecha.hora);
      
      toast.success("Propuesta de nuevo horario enviada al médico.");
      setModalModificarAbierto(false);
      
      setTurnos(turnos.map(t => 
        t.id === datosNuevaFecha.idTurno 
          ? { ...t, fechaPropuesta: datosNuevaFecha.fecha, horaPropuesta: datosNuevaFecha.hora } 
          : t
      ));
      
    } catch (error) {
      toast.error("No se pudo enviar la propuesta.");
    }
  };
  
  const turnosMostrados = turnos.filter((turno) => {
    if (turnoIdDestacado) {
      return turno.id.toString() === turnoIdDestacado;
    }

    if (filtroActivo === "proximos") {
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      const limite7Dias = new Date(hoy);
      limite7Dias.setDate(hoy.getDate() + 7);

      const fechaDelTurno = parsearFecha(turno.fecha);

      return fechaDelTurno >= hoy && fechaDelTurno <= limite7Dias;
    }

    return true; 
  });

  return (
    <div className="turnos-page">
      <div className="turnos-header">
        <h2>Mis Turnos</h2>
      </div>

      <div className="turnos-container">
        <aside className="turnos-sidebar">
          <ul className="sidebar-menu">
            <li 
              className={filtroActivo === "proximos" ? "active" : ""} 
              onClick={() => manejarCambioPestaña("proximos")}
            >
              Próximos turnos
            </li>
            <li 
              className={filtroActivo === "todos" ? "active" : ""} 
              onClick={() => manejarCambioPestaña("todos")}
            >
              Todos los turnos
            </li>
          </ul>
        </aside>

        <main className="turnos-main-content">
          {cargando ? (
            <div className="turnos-loader-wrapper">
              <Loader />
            </div>
          ) : turnosMostrados.length === 0 ? (
            <div className="turnos-vacios">
              No se encontraron turnos para esta categoría.
            </div>
         ) : (
            <div className="turnos-grid">
              {turnosMostrados.map((turno) => (
                <MisTurnoCard
                  key={turno.id}
                  turno={turno}
                  onCancelar={intentarCancelar}
                  onModificar={abrirModalModificar}
                />
              ))}
            </div>
          )}
        </main>
      </div>

      <Dialog
        open={modalAbierto}
        onClose={cerrarModal}
        PaperProps={{ className: "modal-paper" }}
      >
        <DialogTitle className="modal-titulo" style={{ display: 'flex', s: 'center', gap: '8px' }}>
          <EventBusyRoundedIcon />
          Cancelar turno agendado
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            Estás por cancelar tu turno médico con <strong>{turnoACancelar?.medico}</strong>. ¿Estás seguro/a de que querés continuar?
          </DialogContentText>

                  <TextField
            fullWidth
            multiline
            minRows={3}
            label="Motivo de la cancelación"
            value={motivoCancelacion}
            onChange={(e) => setMotivoCancelacion(e.target.value)}
        />
        </DialogContent>

        <DialogActions className="modal-acciones">
          <Button onClick={cerrarModal} variant="outlined">
            Volver
          </Button>
          <Button onClick={confirmarCancelacion} color="error" variant="contained">
            Sí, cancelar turno
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={modalModificarAbierto}
        onClose={() => setModalModificarAbierto(false)}
        PaperProps={{ className: "modal-paper" }}
      >
        <DialogTitle className="modal-titulo" color="primary" fontWeight="bold">
          Proponer nueva fecha
        </DialogTitle>

        <DialogContent>
          <DialogContentText style={{ marginBottom: '20px' }}>
            Elegí el nuevo día y horario que querés proponerle al médico. El turno actual se mantendrá hasta que el médico confirme el cambio.
          </DialogContentText>
          
          <div style={{ display: 'flex', gap: '15px', flexDirection: 'column' }}>
            <input 
              type="date" 
              className="input-fecha-hora"
              value={datosNuevaFecha.fecha}
              onChange={(e) => setDatosNuevaFecha({...datosNuevaFecha, fecha: e.target.value})}
              style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
            />
            <input 
              type="time" 
              className="input-fecha-hora"
              value={datosNuevaFecha.hora}
              onChange={(e) => setDatosNuevaFecha({...datosNuevaFecha, hora: e.target.value})}
              style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
            />
          </div>
        </DialogContent>

        <DialogActions className="modal-acciones">
          <Button onClick={() => setModalModificarAbierto(false)} variant="outlined">
            Volver
          </Button>
          <Button onClick={confirmarModificacion} color="primary" variant="contained">
            Enviar propuesta
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MisTurnos;